import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  listRecordTaxrates,
  deleteTaxrate,
} from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";
import { TAXRATE_DELETE_RESET } from "../constants/financeConstants";
import Notification from "../components/Notification";
import ConfirmDialog from "../components/ConfirmDialog";

const useStyles = makeStyles(styles);
export default function TaxesList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const recordTaxrateList = useSelector((state) => state.recordTaxrateList);
  const { loading, error, summary } = recordTaxrateList;

  console.log("taxes:" + summary);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const taxrateDelete = useSelector((state) => state.deleteTaxrate);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = taxrateDelete;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: TAXRATE_DELETE_RESET });
    dispatch(listRecordTaxrates());
  }, [dispatch, successDelete]);

  const onDelete = (taxrate) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    // if (window.confirm('Are you sure to delete?')) {
    dispatch(deleteTaxrate(taxrate._id));
    setNotify({
      isOpen: true,
      message: "Taxrate Deleted Successfully",
      type: "success",
    });

    // }
  };
  const getFilterUrl = (filter) => {
    const filterTaxrate = filter.taxrate;
    return `/taxrate/${filterTaxrate}`;
  };

  return (
    <div>
      <h1>Taxes List</h1>
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Taxrate ID</th>
                <th>Taxrate</th>
                <th>Description</th>
                <th>Other information</th>
              </tr>
            </thead>

            <tbody>
              {summary.length === 0 ? (
                <MessageBox>No Record</MessageBox>
              ) : (
                summary.map((taxrate) => (
                  <tr key={taxrate._id}>
                    <td>{taxrate._id}</td>
                    <td>{taxrate.taxrate}</td>
                    <td>{taxrate.description}</td>
                    <td>{taxrate.otherinfo}</td>
                    <td>
                      <Button>
                        <Link to={getFilterUrl({ taxrate: taxrate._id })}>
                          {[t("wordslib.tax"), t("wordslib.detail")]}
                        </Link>
                      </Button>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="small"
                        onClick={() => {
                          setConfirmDialog({
                            isOpen: true,
                            title: "Are you sure to delete the Taxrate?",
                            subTitle:
                              "You can't UNDO this operation once you click YES!",
                            onConfirm: () => {
                              onDelete(taxrate);
                            },
                          });
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </>
      )}
      <Notification notify={notify} setNotify={setNotify}></Notification>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
}
